import React from 'react';

import MainLayout from 'layouts/MainLayout';
import YoutubeList from 'components/shared/YoutubeList';

const Main = () => {
  return (
    <MainLayout>
      <YoutubeList />
    </MainLayout>
  );
};

export default Main;
